import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createVNode as _createVNode, withCtx as _withCtx, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, vModelCheckbox as _vModelCheckbox, renderSlot as _renderSlot, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "table" }
const _hoisted_2 = { class: "selects" }
const _hoisted_3 = { class: "project-name" }
const _hoisted_4 = {
  key: 1,
  class: "project-activity"
}
const _hoisted_5 = {
  key: 2,
  class: "project-activity"
}
const _hoisted_6 = ["onUpdate:modelValue", "disabled"]
const _hoisted_7 = { class: "project-type" }
const _hoisted_8 = {
  key: 0,
  class: "buttons"
}
const _hoisted_9 = { class: "calendar" }
const _hoisted_10 = { class: "dates" }
const _hoisted_11 = ["index"]
const _hoisted_12 = { key: 1 }
const _hoisted_13 = ["onUpdate:modelValue", "disabled"]
const _hoisted_14 = ["onUpdate:modelValue", "onInput", "disabled"]
const _hoisted_15 = ["onClick"]
const _hoisted_16 = ["onClick"]
const _hoisted_17 = { class: "content day-info" }
const _hoisted_18 = { class: "content" }
const _hoisted_19 = ["onUpdate:modelValue", "disabled", "onInput"]
const _hoisted_20 = { class: "sum" }
const _hoisted_21 = { key: 0 }
const _hoisted_22 = { key: 0 }
const _hoisted_23 = { key: 0 }
const _hoisted_24 = ["disabled", "value"]
const _hoisted_25 = ["disabled", "value"]
const _hoisted_26 = { class: "footer" }
const _hoisted_27 = {
  key: 0,
  class: "buttons"
}

import VueSelect from "vue-select";
import LoadingDownloadScreen from "@/components/util/LoadingDownloadScreen.vue";
import { computed, onMounted, reactive, ref } from "vue";
import { ReportingMonth } from "@/services/entities/Reporting/ReportingMonth";
import { getKey } from "@/common/util";
import { useReportingMonthStore } from "@/stores/reporting";
import { ReportingLine } from "@/services/entities/Reporting/ReportingLine";
import { ReportingLineDay } from "@/services/entities/Reporting/ReportingLineDay";
import CommentModal from "@/components/modals/CommentModal.vue";
import DayInfo from "@/components/report/DayInfo.vue";
import { useVfm } from "vue-final-modal";
import { useUserStore } from "@/stores/user";
import { useProjectStore } from "@/stores/project";
import { Authorization } from "@/services/authenticate";
import DxButton from "devextreme-vue/button";
import { ReportingOvertime } from "@/services/entities/Reporting/ReportingOvertime";
import { showToastError } from "@/toastification";
import Popper from "vue3-popper";
import { useReportStore } from "@/stores/report";
import { parseError } from "@/common/util";
import { DefinitionItem } from "@/services/entities/DefinitionItem";
import ProjectTooltip from "@/components/util/ProjectTooltip.vue";
import ActivityTooltip from "../util/ActivityTooltip.vue";
import { isDateInRange } from "@/common/date"


export default /*@__PURE__*/_defineComponent({
  __name: 'ReportTable',
  props: {
  reportingMonth: { Type: {} as ReportingMonth, default: {} as ReportingMonth },
  dailyCommitment: { Type: Number, default: 0 },
  readonly: { Type: Boolean, default: false },
  saving: { Type: Boolean, default: false },
},
  setup(__props) {

const vfm = useVfm();
const commentModalId = Symbol("commentModalId");
const activityAssignemtnId = Symbol("activityAssignemtnId");

const reportingStore = useReportingMonthStore();
const userStore = useUserStore();
const reportStore = useReportStore();

const isPopperOpen = ref(false);
const isSelectOpen = ref(false);
let hideTimeout = 0;

const hidePopper = () => {
  hideTimeout = setTimeout(() => {
    isPopperOpen.value = false;
  }, 200);
};

const cancelHide = () => {
    clearTimeout(hideTimeout);
};

const openDropdown = () => {
  isSelectOpen.value = true;
  isPopperOpen.value = false;
};

const closeDropdown = () => {
  isSelectOpen.value = false;
};

const props = __props;

const state = reactive({
  monthlyRecord: [{ day: [] }, { day: [] }, { day: [] }] as any[],
  reportingMonth: { Type: {} as ReportingMonth, default: {} as ReportingMonth },
  activeLine: { line: 0, day: 0 },
  lockedDays: [] as number[],
  reportLoading: false,
});

async function getMonthlyUserReport() {
  state.reportLoading = true;
  try {
    await reportStore.downloadMonthlyUser(
      props.reportingMonth.year,
      props.reportingMonth.month,
      props.reportingMonth.userId,
      props.reportingMonth.userName
    );
  } catch (e) {
    console.error(e);
    showToastError("Report was unable to generate: " + parseError(e));
  } finally {
    state.reportLoading = false;
  }
}

onMounted(async () => {
  getLockedDays();
});

onMounted(async () => {
  await userStore.loadUser(props.reportingMonth.userId);
});

function showComment(line: number, day: number) {
  state.activeLine.line = line;
  state.activeLine.day = day;
  vfm.open(commentModalId);
}

function onSelectedProjectChanged(event: any, line: ReportingLine, resetActivity = false) {
  line.projectName = event?.projectName;
  line.projectId = event?.projectId;
  line.project = event;
  line.activityNumber = event?.activityNumber;
  line.activityNumberId = event.activityNumberId;
  line.activity = event.activity;
  line.activityTypeId = event.activityTypeId;
  line.projectType = event.projectType;
  line.projectTypeId = event.projectTypeId;
  line.customActivity = event.customActivity;
  line.isCheckbox = event.isCheckbox;  
  if (resetActivity) {
    line.activity = null;
  }
  line.days.forEach((day) => {
      day.hours = line.project?.isCheckbox ? null : day.hours;
      day.commentBox.text = line.project?.isCheckbox ? "" : day.commentBox.text;   
      day.status = line.project?.isCheckbox ? day.status : null;
    });  
}

async function save() {
  if (props.reportingMonth?.lines.some((a) => a.projectTypeId > 90)) {
    props.reportingMonth?.lines.forEach((a) => {
      a.projectId = a.project?.projectId;
      if (a.projectTypeId > 90 || a.projectTypeId == 2) {
        a.activityTypeId = 0;
        a.activityNumberId =
          props.reportingMonth.projects.find((b) => b.projectId == a.projectId)
            ?.activityNumbers[0]?.activityId ?? "";
      }
    });
  }
  props.reportingMonth.actionAuthor = Authorization.id;
  await reportingStore.saveMonth(props.reportingMonth);
}
// -1 == left, 1 == right, 0 == current - to je weird jo
function checkAdjacentDay(
  days: ReportingLineDay[],
  dayIndex: number,
  lineIndex: number,
  linesCount: number,
  direction: number
) {
  if (!days[dayIndex]?.isWorkDay && lineIndex == 0) {
    if (dayIndex < 1 && (direction == -1 || direction == 0)) {
      return days[dayIndex]?.isWorkDay;
    } else if (dayIndex < 1 && direction == 1) {
      return days[dayIndex + direction]?.isWorkDay;
    }

    return days[dayIndex + direction]?.isWorkDay;
  }
  return false;
}

function addLine(projectType = 0) {
  let newLine = {
    projectTypeId: projectType,
  } as ReportingLine;
  newLine.days = Array.from(
    { length: props.reportingMonth.daysInMonth },
    (_, index) => ({
      isWorkDay: props.reportingMonth.lines[0].days[index].isWorkDay,
      day: index + 1,
      hours: null,
      status: null,
      comment: null,
      commentBox: {
        countryId: 144,
        text: null,
      },
    })
  );
  props.reportingMonth.lines.push(newLine);
}

function deleteLine(index: number) {
  if (props.reportingMonth.lines.length == 1) {
    showToastError("You cannot delete the last line");
    return;
  } else {
    if (props.reportingMonth.deletedLines == null) {
      props.reportingMonth.deletedLines = [] as ReportingLine[];
    }
    props.reportingMonth.deletedLines = props.reportingMonth.deletedLines.concat(props.reportingMonth.lines.splice(index, 1));
  }
  console.log(props.reportingMonth);
}

function getActivityCount(activityId: string) {
  return props.reportingMonth.lines.reduce(
    (count, line) => count + (line.activity?.id === activityId ? 1 : 0),
    0
  );
}

function getProjectCount(projectId: string) {
  return props.reportingMonth.lines.reduce(
    (count, line) => count + (line.project?.projectId === projectId ? 1 : 0),
    0
  );
}

function getLockedDays() {
  for (const interval of props.reportingMonth.lockHistoryItems.filter(
    (a) => a.isLocked
  )) {
    const startDate = new Date(interval.dateFrom);
    const endDate = new Date(interval.dateTo);

    const currentDay = new Date(startDate);
    while (isDateInRange(currentDay, startDate, endDate)) {
      state.lockedDays.push(currentDay.getDate());
      currentDay.setDate(currentDay.getDate() + 1);
    }
  }
}

function getSumAndOT(
  line: (number | null | undefined)[],
  isWorkDay: boolean[],
  i: number
) {
  const day = {
    sum: line?.reduce((sum, a) => (sum ?? 0) + Number(a), 0),
    ot: 0,
  };
  const fOt =
    props.reportingMonth.lines.find((line) => line.projectTypeId == 97)?.days[i]
      .hours ?? 0;
  day.ot = !isWorkDay[0]
    ? day.sum ?? 0
    : (day.sum ?? 0) > 0
      ? (day.sum ?? 0) - props.dailyCommitment
      : 0;

  if (props.reportingMonth.overtimes[i] != undefined) {
    props.reportingMonth.overtimes[i].floatingOvertime = day.ot;
  }
  day.ot = day.ot - fOt - props.reportingMonth.overtimes[i]?.projectOvertime;
  return day;
}

function getSumSumAndOT(line: ReportingLine[]) {
  const day = {
    sum: line
      .map((a) =>
        a.days
          ?.map((b) => b.hours)
          .reduce((sum, b) => (sum ?? 0) + Number(b), 0)
      )
      .reduce((sum, b) => (sum ?? 0) + Number(b), 0),
    ot: 0,
  };
  // working day hours for all days in month
  const workingDaysHours =
    line[0].days
      .map((b) => b.isWorkDay)
      .reduce((sum, b) => (sum ?? 0) + Number(b), 0) * props.dailyCommitment;

  // get floating overtime including project overtime that was not deducted 
  const fOt =
    props.reportingMonth.overtimes.reduce((sum, ot) => sum + ot.floatingOvertime, 0);

  // Deduct project overtime from floating overtime
  day.ot = fOt - props.reportingMonth.overtimes.reduce((sum, ot) => sum + (!Number(ot.projectOvertime) || ot.projectOvertime < 0 ? 0 : ot.projectOvertime ?? 0), 0);

  return day;
}

function getProjectOtSum(overtime: ReportingOvertime[]) {
  return overtime.reduce((sum, ot) => sum + (!Number(ot.projectOvertime) ? 0 : ot.projectOvertime ?? 0), 0);
}

function getDaysInMonth() {
  const date = new Date();
  const year = date.getFullYear();
  const month = date.getMonth() + 1; // Month is zero-based, so we add 1
  return new Date(year, month, 0).getDate();
}

function checkInput(index: number, i: number) {
  let input = props.reportingMonth.lines[index].days[i].hours;
  if (input) {
    if (input > 24) {
      showToastError("Day does not have more than 24 hours");
      props.reportingMonth.lines[index].days[i].hours = 0;
    } else if (input < 0) {
      showToastError("Day value cannot be bellow zero");
      props.reportingMonth.lines[index].days[i].hours = 0;
    } else if (input % 0.5 != 0 ) {
      showToastError("Only half or full hours are allowed");
      if (input < 0.5) {
        props.reportingMonth.lines[index].days[i].hours = 0.5;
      }
      else {
        props.reportingMonth.lines[index].days[i].hours = input - (input % 0.5);
      }
    } else {
      props.reportingMonth.lines[index].days[i].hours = input;
    }
  } else {
    props.reportingMonth.lines[index].days[i].hours = input;
  }
}

function checkOvertimeCompInput(i: number) {
  let input = props.reportingMonth.overtimes[i].projectOvertime;
  if (input) {
    if (input > props.dailyCommitment) {
      showToastError(`You can only compensate ${props.dailyCommitment} hours per day`);
      props.reportingMonth.overtimes[i].projectOvertime = 0;
    } else if (input < 0) {
      showToastError("Overtime compensation cannot be bellow zero");
      props.reportingMonth.overtimes[i].projectOvertime = 0;
    } else if (input % 0.5 != 0.0) {
      showToastError("Only half or full hours are allowed");
      props.reportingMonth.overtimes[i].projectOvertime = input - (input % 0.5);
    } else {
      props.reportingMonth.overtimes[i].projectOvertime = input;
    }
  } else {
    props.reportingMonth.overtimes[i].projectOvertime = input;
  }
}

async function createAssignment(projectId: string, value: DefinitionItem) {
  vfm.close(activityAssignemtnId);
  const projectStore = useProjectStore();
  await projectStore.addDefinitions(projectId, value);
  await reportingStore.loadReportingMonth(
    props.reportingMonth.year,
    props.reportingMonth.month,
    props.reportingMonth.userId
  );
}

function getHolidayNameAndDesc(dayIndex: number) {
  const result = props.reportingMonth.holidays.find(
    (a) => new Date(a.date).getDate() == dayIndex
  );
  if (result) {
    return `${result.name} | ${result.description}`;
  } else {
    return;
  }
}

function checkProjectOvertimeInput(i: number) {
  let input = props.reportingMonth.overtimes[i].projectOvertime;
  let maxOt = props.reportingMonth.overtimes[i].floatingOvertime;
  if (input) {
    if (input > maxOt) {
      showToastError("You can only take " + maxOt + " hours of overtime");
      props.reportingMonth.overtimes[i].projectOvertime = 0;
    } else if (input < 0) {
      showToastError("Project overtime cannot be bellow zero.");
      props.reportingMonth.overtimes[i].projectOvertime = 0;
    } else if (input % 0.5 != 0) {
      showToastError("Only half or full hours are allowed");
      props.reportingMonth.overtimes[i].projectOvertime = input - (input % 0.5);
    } else {
      props.reportingMonth.overtimes[i].projectOvertime = input;
    }
  } else {
    props.reportingMonth.overtimes[i].projectOvertime = input;
  }
}

const dayInfoValue = computed(() => {
    return getSumSumAndOT(props.reportingMonth.lines);
});

const dayInfoThreshold = computed(() => {
    return (
        props.reportingMonth.lines[0].days.filter((a) => a.isWorkDay).length *
        props.dailyCommitment
    );
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _cache[9] || (_cache[9] = _createElementVNode("div", { class: "title" }, [
          _createElementVNode("span", null, "Project name"),
          _createElementVNode("span", null, "Activity name")
        ], -1)),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.reportingMonth.lines, (line, lineIndex) => {
          return (_openBlock(), _createElementBlock("div", {
            key: _unref(getKey)('selects', lineIndex),
            class: "project-type"
          }, [
            (!line.days.some((a) => (a.hours ?? 0) > 0 || a.status))
              ? (_openBlock(), _createBlock(_unref(DxButton), {
                  key: 0,
                  disabled: props.readonly,
                  icon: "trash",
                  class: "line-delete",
                  onClick: ($event: any) => (deleteLine(lineIndex))
                }, null, 8, ["disabled", "onClick"]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_3, [
              (line.projectTypeId >= 90)
                ? (_openBlock(), _createBlock(_unref(Popper), {
                    key: 0,
                    hover: "",
                    placement: "top",
                    openDelay: "250",
                    closeDelay: "500",
                    arrow: "",
                    class: "tooltip",
                    onMouseenter: cancelHide,
                    onMouseleave: hidePopper,
                    isOpen: isPopperOpen.value,
                    disabled: !line.project || isSelectOpen.value
                  }, {
                    content: _withCtx(() => [
                      _createVNode(ProjectTooltip, {
                        project: line.project
                      }, null, 8, ["project"])
                    ]),
                    default: _withCtx(() => [
                      _createVNode(_unref(VueSelect), {
                        label: "projectLabel",
                        options: props.reportingMonth.projects.filter((a) => a.projectTypeId >= 90),
                        onOpen: openDropdown,
                        onClose: closeDropdown,
                        clearable: false,
                        disabled: props.readonly || line.days.some((a) => ((a.hours ?? 0) > 0 || a.status) && state.lockedDays.includes(a.day)),
                        modelValue: line.project,
                        "onUpdate:modelValue": ($event: any) => ((line.project) = $event),
                        class: _normalizeClass({'border-red': getProjectCount(line.project?.projectId) > 1,}),
                        "onOption:selected": ($event: any) => (onSelectedProjectChanged($event, line, false))
                      }, null, 8, ["options", "disabled", "modelValue", "onUpdate:modelValue", "class", "onOption:selected"])
                    ]),
                    _: 2
                  }, 1032, ["isOpen", "disabled"]))
                : (line.projectTypeId == 0)
                  ? (_openBlock(), _createBlock(_unref(Popper), {
                      key: 1,
                      hover: "",
                      placement: "top",
                      openDelay: "250",
                      closeDelay: "500",
                      arrow: "",
                      class: "tooltip",
                      onMouseenter: cancelHide,
                      onMouseleave: hidePopper,
                      isOpen: isPopperOpen.value,
                      disabled: !line.project || isSelectOpen.value
                    }, {
                      content: _withCtx(() => [
                        _createVNode(ProjectTooltip, {
                          project: line.project
                        }, null, 8, ["project"])
                      ]),
                      default: _withCtx(() => [
                        _createVNode(_unref(VueSelect), {
                          label: "projectLabel",
                          options: props.reportingMonth.projects.filter((a) => a.projectTypeId <= 1),
                          clearable: false,
                          "onOption:selected": ($event: any) => (onSelectedProjectChanged($event, line, true)),
                          onOpen: openDropdown,
                          onClose: closeDropdown,
                          disabled: props.readonly || line.days.some((a) => ((a.hours ?? 0) > 0 || a.status) && state.lockedDays.includes(a.day)),
                          modelValue: line.project,
                          "onUpdate:modelValue": ($event: any) => ((line.project) = $event)
                        }, null, 8, ["options", "onOption:selected", "disabled", "modelValue", "onUpdate:modelValue"])
                      ]),
                      _: 2
                    }, 1032, ["isOpen", "disabled"]))
                  : (_openBlock(), _createBlock(_unref(Popper), {
                      key: 2,
                      hover: "",
                      placement: "top",
                      openDelay: "250",
                      closeDelay: "500",
                      arrow: "",
                      class: "tooltip",
                      onMouseenter: cancelHide,
                      onMouseleave: hidePopper,
                      isOpen: isPopperOpen.value,
                      disabled: !line.project || isSelectOpen.value
                    }, {
                      content: _withCtx(() => [
                        _createVNode(ProjectTooltip, {
                          project: line.project
                        }, null, 8, ["project"])
                      ]),
                      default: _withCtx(() => [
                        _createVNode(_unref(VueSelect), {
                          label: "projectLabel",
                          modelValue: line.project,
                          "onUpdate:modelValue": ($event: any) => ((line.project) = $event),
                          onOpen: openDropdown,
                          onClose: closeDropdown,
                          options: props.reportingMonth.projects.filter((a) => a.projectTypeId == line.projectTypeId),
                          clearable: false,
                          disabled: props.readonly || line.days.some((a) => ((a.hours ?? 0) > 0 || a.status) && state.lockedDays.includes(a.day)),
                          class: _normalizeClass({'border-red': !line.project?.isCustomActivity && getProjectCount(line.project?.projectId) > 1,}),
                          "onOption:selected": ($event: any) => (onSelectedProjectChanged($event, line, false))
                        }, null, 8, ["modelValue", "onUpdate:modelValue", "options", "disabled", "class", "onOption:selected"])
                      ]),
                      _: 2
                    }, 1032, ["isOpen", "disabled"]))
            ]),
            (
          line.project && line.projectTypeId < 90 && line.projectTypeId != 2
        )
              ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                  _createVNode(_unref(Popper), {
                    class: "tooltip",
                    hover: "",
                    placement: "top",
                    openDelay: "200",
                    closeDelay: "100"
                  }, {
                    content: _withCtx(() => [
                      _createVNode(ActivityTooltip, {
                        activityDefinition: line.activity
                      }, null, 8, ["activityDefinition"])
                    ]),
                    default: _withCtx(() => [
                      _createVNode(_unref(VueSelect), {
                        label: "activityNumber",
                        options: props.reportingMonth.projects?.find((a) => a.projectId == line.project.projectId)?.activityNumbers,
                        clearable: false,
                        modelValue: line.activity,
                        "onUpdate:modelValue": ($event: any) => ((line.activity) = $event),
                        disabled: props.readonly || line.days.some((a) => (a.hours ?? 0) > 0 && state.lockedDays.includes(a.day)),
                        class: _normalizeClass({'border-red': !line.activity || getActivityCount(line.activity?.id) > 1,})
                      }, null, 8, ["options", "modelValue", "onUpdate:modelValue", "disabled", "class"])
                    ]),
                    _: 2
                  }, 1024)
                ]))
              : (
          line.project &&
          props.reportingMonth.projects.find(
            (a) => a.projectId == line.project.projectId
          )?.isCustomActivity
        )
                ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                    _createElementVNode("div", null, [
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": ($event: any) => ((line.customActivity) = $event),
                        type: "text",
                        maxlength: "20",
                        disabled: props.readonly || line.days.some(
              (a) => (a.hours ?? 0) > 0 && state.lockedDays.includes(a.day)
            )
                      }, null, 8, _hoisted_6), [
                        [_vModelText, line.customActivity]
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true)
          ]))
        }), 128)),
        _createElementVNode("div", _hoisted_7, [
          (!props.readonly)
            ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                _createElementVNode("button", {
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (addLine(0)))
                }, [...(_cache[5] || (_cache[5] = [
                  _createElementVNode("b", null, "+", -1),
                  _createTextVNode("Add project", -1)
                ]))]),
                _createElementVNode("button", {
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (addLine(99)))
                }, [...(_cache[6] || (_cache[6] = [
                  _createElementVNode("b", null, "+", -1),
                  _createTextVNode("Add absence", -1)
                ]))]),
                _createElementVNode("button", {
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (addLine(2)))
                }, [...(_cache[7] || (_cache[7] = [
                  _createElementVNode("b", null, "+", -1),
                  _createTextVNode("Add non invoiced project", -1)
                ]))])
              ]))
            : _createCommentVNode("", true),
          _cache[8] || (_cache[8] = _createStaticVNode("<div class=\"project-activity\" data-v-1ff62704><div class=\"info-box\" data-v-1ff62704><div class=\"info\" data-v-1ff62704> Day Sum </div><div class=\"info\" data-v-1ff62704> Floating OT </div><div class=\"info\" data-v-1ff62704> Project OT </div></div></div>", 1))
        ])
      ]),
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("div", _hoisted_10, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.reportingMonth.lines, (item, index) => {
            return (_openBlock(), _createElementBlock("div", {
              class: _normalizeClass(["content", {
          first: index == 0,
          checkbox: item.project?.isCheckbox,
          checoBoxBox: item.project?.isCheckbox,
        }]),
              key: _unref(getKey)('date', index)
            }, [
              _createElementVNode("div", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.days, (day, dayIndex) => {
                  return (_openBlock(), _createElementBlock("div", {
                    index: index,
                    key: _unref(getKey)(_unref(getKey)('date', index), dayIndex),
                    class: _normalizeClass({
                dayOff: !day.isWorkDay,
              })
                  }, [
                    (index == 0)
                      ? (_openBlock(), _createBlock(_unref(Popper), {
                          key: 0,
                          hover: "",
                          placement: "top",
                          class: "tooltip",
                          content: getHolidayNameAndDesc(dayIndex + 1)
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("span", null, _toDisplayString(dayIndex + 1), 1)
                          ]),
                          _: 2
                        }, 1032, ["content"]))
                      : _createCommentVNode("", true),
                    (item.project)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                          (item.project?.isCheckbox)
                            ? _withDirectives((_openBlock(), _createElementBlock("input", {
                                key: 0,
                                type: "checkbox",
                                class: "small",
                                "onUpdate:modelValue": ($event: any) => ((day.status) = $event),
                                disabled: props.readonly || state.lockedDays.includes(dayIndex + 1)
                              }, null, 8, _hoisted_13)), [
                                [_vModelCheckbox, day.status]
                              ])
                            : _withDirectives((_openBlock(), _createElementBlock("input", {
                                key: 1,
                                type: "number",
                                class: _normalizeClass(["small", {repse: day.isRepse || day.isBT }]),
                                max: "24",
                                "onUpdate:modelValue": ($event: any) => ((day.hours) = $event),
                                min: "0",
                                step: "0.5",
                                onInput: ($event: any) => (checkInput(index, dayIndex)),
                                disabled: props.readonly || state.lockedDays.includes(dayIndex + 1)
                              }, null, 42, _hoisted_14)), [
                                [_vModelText, day.hours]
                              ]),
                          (
                  !item.project?.isCheckbox && day.commentBox?.text?.length > 0
                )
                            ? (_openBlock(), _createBlock(_unref(Popper), {
                                key: 2,
                                content: day.commentBox.text,
                                class: "tooltip",
                                hover: "",
                                openDelay: "200",
                                closeDelay: "100"
                              }, {
                                default: _withCtx(() => [
                                  _createElementVNode("div", {
                                    class: "comment filled",
                                    onClick: () => {
                    showComment(index, dayIndex);
                  }
                  
                                  }, null, 8, _hoisted_15)
                                ]),
                                _: 2
                              }, 1032, ["content"]))
                            : (!item.project?.isCheckbox)
                              ? (_openBlock(), _createElementBlock("div", {
                                  key: 3,
                                  class: "comment",
                                  onClick: () => {
                  showComment(index, dayIndex);
                }
                
                                }, null, 8, _hoisted_16))
                              : _createCommentVNode("", true)
                        ]))
                      : _createCommentVNode("", true)
                  ], 10, _hoisted_11))
                }), 128))
              ])
            ], 2))
          }), 128)),
          _createElementVNode("div", _hoisted_17, [
            _createElementVNode("div", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.reportingMonth.lines[0].days, (item, i) => {
                return (_openBlock(), _createBlock(DayInfo, {
                  key: 'sum_' + i,
                  classa: 0,
                  class: _normalizeClass({dayOff: !item.isWorkDay,}),
                  value: getSumAndOT(props.reportingMonth.lines.map((a) => a.days[i]?.hours), props.reportingMonth.lines.map((a) => a.days[i]?.isWorkDay), i ),
                  threshold: item.isWorkDay ? props.dailyCommitment : null
                }, null, 8, ["class", "value", "threshold"]))
              }), 128))
            ])
          ]),
          _createElementVNode("div", _hoisted_18, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.reportingMonth.overtimes, (item, i) => {
              return (_openBlock(), _createElementBlock("div", {
                key: _unref(getKey)('suma_', i),
                class: _normalizeClass({ first: i == 0, dayOff: item.isWorkday })
              }, [
                _createElementVNode("div", null, [
                  _createElementVNode("div", null, [
                    _withDirectives(_createElementVNode("input", {
                      type: "number",
                      class: "small-22",
                      max: "24",
                      "onUpdate:modelValue": ($event: any) => ((item.projectOvertime) = $event),
                      step: "0.5",
                      disabled: props.readonly || state.lockedDays.includes(i + 1),
                      onInput: ($event: any) => (checkProjectOvertimeInput(i))
                    }, null, 40, _hoisted_19), [
                      [_vModelText, item.projectOvertime]
                    ])
                  ])
                ])
              ], 2))
            }), 128))
          ])
        ]),
        _createElementVNode("div", _hoisted_20, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.reportingMonth.lines, (item, index) => {
            return (_openBlock(), _createElementBlock("div", {
              class: _normalizeClass(["content", { first: index == 0, checkbox: item.project?.isCheckbox }]),
              key: _unref(getKey)('date', index)
            }, [
              (item.project)
                ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                    (!item.project?.isCheckbox)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                          (index == 0)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_23, "SUM"))
                            : _createCommentVNode("", true),
                          _createElementVNode("input", {
                            type: "number",
                            class: "wider-22",
                            max: "24",
                            step: "0.5",
                            disabled: props.readonly,
                            value: item.days
                .map((a) => a.hours)
                .reduce((sum, a) => (sum ?? 0) + Number(a), 0)
                
                          }, null, 8, _hoisted_24)
                        ]))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true)
            ], 2))
          }), 128)),
          _createVNode(DayInfo, {
            value: dayInfoValue.value,
            threshold: dayInfoThreshold.value,
            classa: 1
          }, null, 8, ["value", "threshold"]),
          _createElementVNode("input", {
            type: "number",
            class: "wider-22",
            step: "0.5",
            disabled: props.readonly,
            value: getProjectOtSum(props.reportingMonth.overtimes)
          }, null, 8, _hoisted_25)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_26, [
      _createVNode(_unref(Popper), {
        content: "Indicates Site work",
        class: "tooltip",
        hover: "",
        openDelay: "200",
        closeDelay: "100"
      }, {
        default: _withCtx(() => [...(_cache[10] || (_cache[10] = [
          _createElementVNode("div", { class: "legend" }, [
            _createElementVNode("input", {
              id: "repse_legend",
              class: "small repse",
              disabled: "true",
              value: "null",
              type: "number"
            }),
            _createElementVNode("label", { for: "repse_legend" }, "Site work/Business trip")
          ], -1)
        ]))]),
        _: 1
      }),
      (!props.saving)
        ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
            _createElementVNode("button", { onClick: getMonthlyUserReport }, "Export to excel"),
            _renderSlot(_ctx.$slots, "buttons")
          ]))
        : _createCommentVNode("", true)
    ]),
    (props.reportingMonth.lines)
      ? (_openBlock(), _createBlock(CommentModal, {
          key: 0,
          "modal-id": _unref(commentModalId),
          disabled: state.lockedDays.includes(state.activeLine.day + 1),
          modelValue: props.reportingMonth.lines[state.activeLine.line].days[state.activeLine.day],
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((props.reportingMonth.lines[state.activeLine.line].days[state.activeLine.day]) = $event)),
          onClose: _cache[4] || (_cache[4] = ($event: any) => (_unref(vfm).close(_unref(commentModalId))))
        }, null, 8, ["modal-id", "disabled", "modelValue"]))
      : _createCommentVNode("", true),
    (state.reportLoading)
      ? (_openBlock(), _createBlock(LoadingDownloadScreen, { key: 1 }))
      : _createCommentVNode("", true)
  ], 64))
}
}

})